import { useEffect, useState } from "react"
import { lessonsApi, userApi } from "../api/api"
import { simpleGetter } from "../actions/common"

const useLessonByRoomName = (roomName, trigger) => {
    const [data, setData] = useState({})

    const fetchData = async () => {
        const response = await simpleGetter(lessonsApi.ongoing, roomName)
        if (response.success) {
            setData(response.lesson)
        }
    }

    useEffect(() => {
        if (roomName?.length) {
            fetchData()
        }
    }, [roomName, trigger])

    return data
}

const useTeacherCourses = (trigger) => {
    const [data, setData] = useState([])

    const fetchData = async () => {
        const response = await simpleGetter(userApi.getTeacherClasses)
        if (response.success) {
            setData(response.list)
        }
    }

    useEffect(() => {
        fetchData()
    }, [trigger])

    return data
}

export {
    useLessonByRoomName,
    useTeacherCourses
}